import React from "react";
import Image from '~/components/atoms/Image'
import TextCard from "~/components/molecules/TextCard";
import FadeInWhenVisible from '~/components/FadeInWhenVisible'
import CtaContactSection from '~/components/organisms/CtaContactSection';

export default function Cta({key, index, ...props}) {

  const section = props.cta

  // Original Cta design (image/illustration + TextCard), kept for reference.
  // return ((section?.textCard?.length > 0) || (section?.illustration)) ? (
  //   <section className="my-20 md:my-36" id={section.fieldGroupName + index} >
  //     <FadeInWhenVisible className="container">
  //       <div className="grid grid-cols-12 items-center bg-navy text-white px-10 py-20 lg:py-0 lg:px-0">
  //         <div className="col-span-12 lg:col-span-6 ">
  //           {section?.illustration && <Image data={section.illustration} className={`${section.illustrationSize === 'normal' ? 'w-40 md:w-64 md:mx-auto' : 'w-full'} `} />}
  //         </div>
  //         <div className="col-span-12 lg:col-span-6  lg:p-20 lg:px-24 flex flex-col justify-center items-start">
  //           <TextCard {...section?.textCard} />
  //         </div>
  //       </div>
  //     </FadeInWhenVisible>
  //   </section>
  // ) : null;

  if (!section) return null;

  const textCard = section?.textCard

  return (
    <CtaContactSection
      index={index}
      ctaContactSection={{
        heading: textCard?.heading?.text || 'Get in touch with us',
        subtext: textCard?.content || 'Our team is here to help with any questions.',
        callUsLink: 'tel:+442038650611',
        emailUsLink: 'mailto:info@cityrelay.com',
      }}
    />
  );
}
